import { useTranslation } from "react-i18next";
import { FleetioHero } from "~/components/integration/fleetio/FleetioHero";
import { FleetioSections } from "~/components/integration/fleetio/FleetioSections";
import { FleetioFaq } from "~/components/integration/fleetio/FleetioFaq";

export default function FleetioIntegration() {
  const { t } = useTranslation("fleetio");
  return (
    <>
      <title>{t("title")}</title>
      <meta name="description" content={t("description")} />
      <FleetioHero />
      <FleetioSections />
      <FleetioFaq />
    </>
  );
}
